var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16.5 16.1848",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.87175 3.21229L10.5378 0.828726C11.0526 0.612163 11.645 0.859233 11.8534 1.3774L12.5257 3.04944M15.4696 7.17788H11.9322C10.8277 7.17788 9.93224 8.07331 9.93224 9.17788V9.44393C9.93224 10.5485 10.8277 11.4439 11.9322 11.4439H15.4696M15.75 6.25586V12.4348C15.75 14.0916 14.4069 15.4348 12.75 15.4348H3.75C2.09315 15.4348 0.75 14.0916 0.75 12.4348V6.25586C0.75 4.59901 2.09315 3.25586 3.75 3.25586H12.75C14.4069 3.25586 15.75 4.59901 15.75 6.25586Z",
    stroke: "var(--stroke-0, #875BF7)",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.7f62efddb69a6870ce8d74772ded4b5d.svg";
export { ForwardRef as ReactComponent };